export default {
    props: {
        aggregate: {
            type: String | Function,
            kComposite: 'aggregate'
        }, 
        axis: {
            type: String,
            kComposite: 'axis'
        }, 
        borderColor: {
            type: String | Function,
            kComposite: 'border.color'
        }, 
        borderDashType: {
            type: String | Function,
            kComposite: 'border.dashType'
        }, 
        borderOpacity: {
            type: Number | Function,
            kComposite: 'border.opacity'
        }, 
        borderWidth: {
            type: Number | Function,
            kComposite: 'border.width'
        }, 
        categoryAxis: {
            type: String,
            kComposite: 'categoryAxis'
        }, 
        categoryField: {
            type: String,
            kComposite: 'categoryField'
        }, 
        closeField: {
            type: String,
            kComposite: 'closeField'
        }, 
        color: {
            type: String | Function,
            kComposite: 'color'
        }, 
        colorField: {
            type: String,
            kComposite: 'colorField'
        }, 
        connectorsColor: {
            type: String | Function,
            kComposite: 'connectors.color'
        }, 
        connectorsPadding: {
            type: Number,
            kComposite: 'connectors.padding'
        }, 
        connectorsWidth: {
            type: Number,
            kComposite: 'connectors.width'
        }, 
        currentField: {
            type: String,
            kComposite: 'currentField'
        }, 
        dashType: {
            type: String,
            kComposite: 'dashType'
        }, 
        data: {
            type: Array,
            kComposite: 'data'
        }, 
        downColor: {
            type: String | Function,
            kComposite: 'downColor'
        }, 
        downColorField: {
            type: String,
            kComposite: 'downColorField'
        }, 
        segmentSpacing: {
            type: Number,
            kComposite: 'segmentSpacing'
        }, 
        summaryField: {
            type: String,
            kComposite: 'summaryField'
        }, 
        neckRatio: {
            type: Number,
            kComposite: 'neckRatio'
        }, 
        dynamicSlope: {
            type: Boolean,
            kComposite: 'dynamicSlope'
        }, 
        dynamicHeight: {
            type: Boolean,
            kComposite: 'dynamicHeight'
        }, 
        errorBarsValue: {
            type: String | Number | Array | Function,
            kComposite: 'errorBars.value'
        }, 
        errorBarsVisual: {
            type: Function,
            kComposite: 'errorBars.visual'
        }, 
        errorBarsXValue: {
            type: String | Number | Array | Function,
            kComposite: 'errorBars.xValue'
        }, 
        errorBarsYValue: {
            type: String | Number | Array | Function,
            kComposite: 'errorBars.yValue'
        }, 
        errorBarsEndCaps: {
            type: Boolean,
            kComposite: 'errorBars.endCaps'
        }, 
        errorBarsColor: {
            type: String,
            kComposite: 'errorBars.color'
        }, 
        errorBarslineWidth: {
            type: Number,
            kComposite: 'errorBars.line.width'
        }, 
        errorBarslineDashType: {
            type: String,
            kComposite: 'errorBars.line.dashType'
        }, 
        errorLowField: {
            type: String,
            kComposite: 'errorLowField'
        }, 
        errorHighField: {
            type: String,
            kComposite: 'errorHighField'
        }, 
        xErrorLowField: {
            type: String,
            kComposite: 'xErrorLowField'
        }, 
        xErrorHighField: {
            type: String,
            kComposite: 'xErrorHighField'
        }, 
        yErrorLowField: {
            type: String,
            kComposite: 'yErrorLowField'
        }, 
        yErrorHighField: {
            type: String,
            kComposite: 'yErrorHighField'
        }, 
        explodeField: {
            type: String,
            kComposite: 'explodeField'
        }, 
        field: {
            type: String,
            kComposite: 'field'
        }, 
        fromField: {
            type: String,
            kComposite: 'fromField'
        }, 
        toField: {
            type: String,
            kComposite: 'toField'
        }, 
        noteTextField: {
            type: String,
            kComposite: 'noteTextField'
        }, 
        lowerField: {
            type: String,
            kComposite: 'lowerField'
        }, 
        q1Field: {
            type: String,
            kComposite: 'q1Field'
        }, 
        medianField: {
            type: String,
            kComposite: 'medianField'
        }, 
        q3Field: {
            type: String,
            kComposite: 'q3Field'
        }, 
        upperField: {
            type: String,
            kComposite: 'upperField'
        }, 
        meanField: {
            type: String,
            kComposite: 'meanField'
        }, 
        outliersField: {
            type: String,
            kComposite: 'outliersField'
        }, 
        gap: {
            type: Number,
            kComposite: 'gap'
        }, 
        highField: {
            type: String,
            kComposite: 'highField'
        }, 
        highlightBorderColor: {
            type: String,
            kComposite: 'highlight.border.color'
        }, 
        highlightBorderOpacity: {
            type: Number,
            kComposite: 'highlight.border.opacity'
        }, 
        highlightBorderWidth: {
            type: Number,
            kComposite: 'highlight.border.width'
        }, 
        highlightColor: {
            type: String,
            kComposite: 'highlight.color'
        }, 
        highlightlineDashType: {
            type: String,
            kComposite: 'highlight.line.dashType'
        }, 
        highlightlineColor: {
            type: String,
            kComposite: 'highlight.line.color'
        }, 
        highlightlineOpacity: {
            type: Number,
            kComposite: 'highlight.line.opacity'
        }, 
        highlightlineWidth: {
            type: Number,
            kComposite: 'highlight.line.width'
        }, 
        highlightOpacity: {
            type: Number,
            kComposite: 'highlight.opacity'
        }, 
        highlightToggle: {
            type: Function,
            kComposite: 'highlight.toggle'
        }, 
        highlightVisible: {
            type: Boolean,
            kComposite: 'highlight.visible'
        }, 
        highlightVisual: {
            type: Function,
            kComposite: 'highlight.visual'
        }, 
        holeSize: {
            type: Number,
            kComposite: 'holeSize'
        }, 
        labelsAlign: {
            type: String,
            kComposite: 'labels.align'
        }, 
        labelsBackground: {
            type: String | Function,
            kComposite: 'labels.background'
        }, 
        labelsBorderColor: {
            type: String | Function,
            kComposite: 'labels.border.color'
        }, 
        labelsBorderDashType: {
            type: String | Function,
            kComposite: 'labels.border.dashType'
        }, 
        labelsBorderWidth: {
            type: Number | Function,
            kComposite: 'labels.border.width'
        }, 
        labelsColor: {
            type: String | Function,
            kComposite: 'labels.color'
        }, 
        labelsDistance: {
            type: Number,
            kComposite: 'labels.distance'
        }, 
        labelsFont: {
            type: String | Function,
            kComposite: 'labels.font'
        }, 
        labelsFormat: {
            type: String | Function,
            kComposite: 'labels.format'
        }, 
        labelsmargin: {
            type: Number,
            kComposite: 'labels.margin'
        }, 
        labelsmarginBottom: {
            type: Number,
            kComposite: 'labels.margin.bottom'
        }, 
        labelsmarginLeft: {
            type: Number,
            kComposite: 'labels.margin.left'
        }, 
        labelsmarginRight: {
            type: Number,
            kComposite: 'labels.margin.right'
        }, 
        labelsmarginTop: {
            type: Number,
            kComposite: 'labels.margin.top'
        }, 
        labelsPadding: {
            type: Number,
            kComposite: 'labels.padding'
        }, 
        labelsPaddingBottom: {
            type: Number,
            kComposite: 'labels.padding.bottom'
        }, 
        labelsPaddingLeft: {
            type: Number,
            kComposite: 'labels.padding.left'
        }, 
        labelsPaddingRight: {
            type: Number,
            kComposite: 'labels.padding.right'
        }, 
        labelsPaddingTop: {
            type: Number,
            kComposite: 'labels.padding.top'
        }, 
        labelsPosition: {
            type: String | Function,
            kComposite: 'labels.position'
        }, 
        labelsRotation: {
            type: String | Number,
            kComposite: 'labels.rotation'
        }, 
        labelsTemplate: {
            type: String | Function,
            kComposite: 'labels.template'
        }, 
        labelsVisible: {
            type: Boolean | Function,
            kComposite: 'labels.visible'
        }, 
        labelsVisual: {
            type: Function,
            kComposite: 'labels.visual'
        }, 
        labelsFromBackground: {
            type: String | Function,
            kComposite: 'labels.from.background'
        }, 
        labelsFromBorderColor: {
            type: String | Function,
            kComposite: 'labels.from.border.color'
        }, 
        labelsFromBorderDashType: {
            type: String | Function,
            kComposite: 'labels.from.border.dashType'
        }, 
        labelsFromBorderWidth: {
            type: Number | Function,
            kComposite: 'labels.from.border.width'
        }, 
        labelsFromColor: {
            type: String | Function,
            kComposite: 'labels.from.color'
        }, 
        labelsFromFont: {
            type: String | Function,
            kComposite: 'labels.from.font'
        }, 
        labelsFromFormat: {
            type: String | Function,
            kComposite: 'labels.from.format'
        }, 
        labelsFrommargin: {
            type: Number,
            kComposite: 'labels.from.margin'
        }, 
        labelsFrommarginBottom: {
            type: Number,
            kComposite: 'labels.from.margin.bottom'
        }, 
        labelsFrommarginLeft: {
            type: Number,
            kComposite: 'labels.from.margin.left'
        }, 
        labelsFrommarginRight: {
            type: Number,
            kComposite: 'labels.from.margin.right'
        }, 
        labelsFrommarginTop: {
            type: Number,
            kComposite: 'labels.from.margin.top'
        }, 
        labelsFromPadding: {
            type: Number,
            kComposite: 'labels.from.padding'
        }, 
        labelsFromPaddingBottom: {
            type: Number,
            kComposite: 'labels.from.padding.bottom'
        }, 
        labelsFromPaddingLeft: {
            type: Number,
            kComposite: 'labels.from.padding.left'
        }, 
        labelsFromPaddingRight: {
            type: Number,
            kComposite: 'labels.from.padding.right'
        }, 
        labelsFromPaddingTop: {
            type: Number,
            kComposite: 'labels.from.padding.top'
        }, 
        labelsFromPosition: {
            type: String | Function,
            kComposite: 'labels.from.position'
        }, 
        labelsFromTemplate: {
            type: String | Function,
            kComposite: 'labels.from.template'
        }, 
        labelsFromVisible: {
            type: Boolean | Function,
            kComposite: 'labels.from.visible'
        }, 
        labelsToBackground: {
            type: String | Function,
            kComposite: 'labels.to.background'
        }, 
        labelsToBorderColor: {
            type: String | Function,
            kComposite: 'labels.to.border.color'
        }, 
        labelsToBorderDashType: {
            type: String | Function,
            kComposite: 'labels.to.border.dashType'
        }, 
        labelsToBorderWidth: {
            type: Number | Function,
            kComposite: 'labels.to.border.width'
        }, 
        labelsToColor: {
            type: String | Function,
            kComposite: 'labels.to.color'
        }, 
        labelsToFont: {
            type: String | Function,
            kComposite: 'labels.to.font'
        }, 
        labelsToFormat: {
            type: String | Function,
            kComposite: 'labels.to.format'
        }, 
        labelsTomargin: {
            type: Number,
            kComposite: 'labels.to.margin'
        }, 
        labelsTomarginBottom: {
            type: Number,
            kComposite: 'labels.to.margin.bottom'
        }, 
        labelsTomarginLeft: {
            type: Number,
            kComposite: 'labels.to.margin.left'
        }, 
        labelsTomarginRight: {
            type: Number,
            kComposite: 'labels.to.margin.right'
        }, 
        labelsTomarginTop: {
            type: Number,
            kComposite: 'labels.to.margin.top'
        }, 
        labelsToPadding: {
            type: Number,
            kComposite: 'labels.to.padding'
        }, 
        labelsToPaddingBottom: {
            type: Number,
            kComposite: 'labels.to.padding.bottom'
        }, 
        labelsToPaddingLeft: {
            type: Number,
            kComposite: 'labels.to.padding.left'
        }, 
        labelsToPaddingRight: {
            type: Number,
            kComposite: 'labels.to.padding.right'
        }, 
        labelsToPaddingTop: {
            type: Number,
            kComposite: 'labels.to.padding.top'
        }, 
        labelsToPosition: {
            type: String | Function,
            kComposite: 'labels.to.position'
        }, 
        labelsToTemplate: {
            type: String | Function,
            kComposite: 'labels.to.template'
        }, 
        labelsToVisible: {
            type: Boolean | Function,
            kComposite: 'labels.to.visible'
        }, 
        line: {
            type: String,
            kComposite: 'line'
        }, 
        lineColor: {
            type: String,
            kComposite: 'line.color'
        }, 
        lineOpacity: {
            type: Number,
            kComposite: 'line.opacity'
        }, 
        lineWidth: {
            type: String,
            kComposite: 'line.width'
        }, 
        lineStyle: {
            type: String,
            kComposite: 'line.style'
        }, 
        lowField: {
            type: String,
            kComposite: 'lowField'
        }, 
        margin: {
            type: Number,
            kComposite: 'margin'
        }, 
        marginBottom: {
            type: Number,
            kComposite: 'margin.bottom'
        }, 
        marginLeft: {
            type: Number,
            kComposite: 'margin.left'
        }, 
        marginRight: {
            type: Number,
            kComposite: 'margin.right'
        }, 
        marginTop: {
            type: Number,
            kComposite: 'margin.top'
        }, 
        markersBackground: {
            type: String | Function,
            kComposite: 'markers.background'
        }, 
        markersBorder: {
            type: Function,
            kComposite: 'markers.border'
        }, 
        markersBorderColor: {
            type: String | Function,
            kComposite: 'markers.border.color'
        }, 
        markersBorderWidth: {
            type: Number | Function,
            kComposite: 'markers.border.width'
        }, 
        markersFromBackground: {
            type: String | Function,
            kComposite: 'markers.from.background'
        }, 
        markersFromBorder: {
            type: Function,
            kComposite: 'markers.from.border'
        }, 
        markersFromBorderColor: {
            type: String | Function,
            kComposite: 'markers.from.border.color'
        }, 
        markersFromBorderWidth: {
            type: Number | Function,
            kComposite: 'markers.from.border.width'
        }, 
        markersFromSize: {
            type: Number | Function,
            kComposite: 'markers.from.size'
        }, 
        markersFromType: {
            type: String | Function,
            kComposite: 'markers.from.type'
        }, 
        markersFromVisible: {
            type: Boolean | Function,
            kComposite: 'markers.from.visible'
        }, 
        markersFromVisual: {
            type: Function,
            kComposite: 'markers.from.visual'
        }, 
        markersFromRotation: {
            type: Number | Function,
            kComposite: 'markers.from.rotation'
        }, 
        markersSize: {
            type: Number | Function,
            kComposite: 'markers.size'
        }, 
        markersToBackground: {
            type: String | Function,
            kComposite: 'markers.to.background'
        }, 
        markersToBorder: {
            type: Function,
            kComposite: 'markers.to.border'
        }, 
        markersToBorderColor: {
            type: String | Function,
            kComposite: 'markers.to.border.color'
        }, 
        markersToBorderWidth: {
            type: Number | Function,
            kComposite: 'markers.to.border.width'
        }, 
        markersToSize: {
            type: Number | Function,
            kComposite: 'markers.to.size'
        }, 
        markersToType: {
            type: String | Function,
            kComposite: 'markers.to.type'
        }, 
        markersToVisible: {
            type: Boolean | Function,
            kComposite: 'markers.to.visible'
        }, 
        markersToVisual: {
            type: Function,
            kComposite: 'markers.to.visual'
        }, 
        markersToRotation: {
            type: Number | Function,
            kComposite: 'markers.to.rotation'
        }, 
        markersType: {
            type: String | Function,
            kComposite: 'markers.type'
        }, 
        markersVisible: {
            type: Boolean | Function,
            kComposite: 'markers.visible'
        }, 
        markersVisual: {
            type: Function,
            kComposite: 'markers.visual'
        }, 
        markersRotation: {
            type: Number | Function,
            kComposite: 'markers.rotation'
        }, 
        outliersBackground: {
            type: String | Function,
            kComposite: 'outliers.background'
        }, 
        outliersBorder: {
            type: Function,
            kComposite: 'outliers.border'
        }, 
        outliersBorderColor: {
            type: String | Function,
            kComposite: 'outliers.border.color'
        }, 
        outliersBorderWidth: {
            type: Number | Function,
            kComposite: 'outliers.border.width'
        }, 
        outliersSize: {
            type: Number | Function,
            kComposite: 'outliers.size'
        }, 
        outliersType: {
            type: String | Function,
            kComposite: 'outliers.type'
        }, 
        outliersRotation: {
            type: Number | Function,
            kComposite: 'outliers.rotation'
        }, 
        extremesBackground: {
            type: String | Function,
            kComposite: 'extremes.background'
        }, 
        extremesBorder: {
            type: Function,
            kComposite: 'extremes.border'
        }, 
        extremesBorderColor: {
            type: String | Function,
            kComposite: 'extremes.border.color'
        }, 
        extremesBorderWidth: {
            type: Number | Function,
            kComposite: 'extremes.border.width'
        }, 
        extremesSize: {
            type: Number | Function,
            kComposite: 'extremes.size'
        }, 
        extremesType: {
            type: String | Function,
            kComposite: 'extremes.type'
        }, 
        extremesRotation: {
            type: Number | Function,
            kComposite: 'extremes.rotation'
        }, 
        maxSize: {
            type: Number,
            kComposite: 'maxSize'
        }, 
        minSize: {
            type: Number,
            kComposite: 'minSize'
        }, 
        missingValues: {
            type: String,
            kComposite: 'missingValues'
        }, 
        kStyle: {
            type: String,
            kComposite: 'style'
        }, 
        name: {
            type: String,
            kComposite: 'name'
        }, 
        negativeColor: {
            type: String,
            kComposite: 'negativeColor'
        }, 
        negativeValuesColor: {
            type: String,
            kComposite: 'negativeValues.color'
        }, 
        negativeValuesVisible: {
            type: Boolean,
            kComposite: 'negativeValues.visible'
        }, 
        opacity: {
            type: Number,
            kComposite: 'opacity'
        }, 
        openField: {
            type: String,
            kComposite: 'openField'
        }, 
        overlayGradient: {
            type: String,
            kComposite: 'overlay.gradient'
        }, 
        padding: {
            type: Number,
            kComposite: 'padding'
        }, 
        size: {
            type: Number,
            kComposite: 'size'
        }, 
        sizeField: {
            type: String,
            kComposite: 'sizeField'
        }, 
        spacing: {
            type: Number,
            kComposite: 'spacing'
        }, 
        stack: {
            type: Boolean | String,
            kComposite: 'stack'
        }, 
        stackType: {
            type: String,
            kComposite: 'stack.type'
        }, 
        stackGroup: {
            type: String,
            kComposite: 'stack.group'
        }, 
        startAngle: {
            type: Number,
            kComposite: 'startAngle'
        }, 
        targetBorder: {
            type: Function,
            kComposite: 'target.border'
        }, 
        targetBorderColor: {
            type: String | Function,
            kComposite: 'target.border.color'
        }, 
        targetBorderDashType: {
            type: String | Function,
            kComposite: 'target.border.dashType'
        }, 
        targetBorderWidth: {
            type: Number | Function,
            kComposite: 'target.border.width'
        }, 
        targetColor: {
            type: String | Function,
            kComposite: 'target.color'
        }, 
        targetlineWidth: {
            type: Object | Function,
            kComposite: 'target.line.width'
        }, 
        targetField: {
            type: String,
            kComposite: 'targetField'
        }, 
        tooltipBackground: {
            type: String,
            kComposite: 'tooltip.background'
        }, 
        tooltipBorderColor: {
            type: String,
            kComposite: 'tooltip.border.color'
        }, 
        tooltipBorderWidth: {
            type: Number,
            kComposite: 'tooltip.border.width'
        }, 
        tooltipColor: {
            type: String,
            kComposite: 'tooltip.color'
        }, 
        tooltipFont: {
            type: String,
            kComposite: 'tooltip.font'
        }, 
        tooltipFormat: {
            type: String,
            kComposite: 'tooltip.format'
        }, 
        tooltipPadding: {
            type: Number,
            kComposite: 'tooltip.padding'
        }, 
        tooltipPaddingBottom: {
            type: Number,
            kComposite: 'tooltip.padding.bottom'
        }, 
        tooltipPaddingLeft: {
            type: Number,
            kComposite: 'tooltip.padding.left'
        }, 
        tooltipPaddingRight: {
            type: Number,
            kComposite: 'tooltip.padding.right'
        }, 
        tooltipPaddingTop: {
            type: Number,
            kComposite: 'tooltip.padding.top'
        }, 
        tooltipTemplate: {
            type: String | Function,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            kComposite: 'tooltip.visible'
        }, 
        type: {
            type: String,
            kComposite: 'type'
        }, 
        visible: {
            type: Boolean,
            kComposite: 'visible'
        },
        visibleInLegend: {
            type: Boolean,
            kComposite: 'visibleInLegend'
        }, 
        visibleInLegendField: {
            type: String,
            kComposite: 'visibleInLegendField'
        }, 
        visual: {
            type: Function,
            kComposite: 'visual'
        }, 
        width: {
            type: Number,
            kComposite: 'width'
        }, 
        xAxis: {
            type: String,
            kComposite: 'xAxis'
        }, 
        xField: {
            type: String,
            kComposite: 'xField'
        }, 
        yAxis: {
            type: String,
            kComposite: 'yAxis'
        }, 
        yField: {
            type: String,
            kComposite: 'yField'
        }, 
        notesPosition: {
            type: String,
            kComposite: 'notes.position'
        }, 
        notesIconBackground: {
            type: String,
            kComposite: 'notes.icon.background'
        }, 
        notesIconBorderColor: {
            type: String,
            kComposite: 'notes.icon.border.color'
        }, 
        notesIconBorderWidth: {
            type: Number,
            kComposite: 'notes.icon.border.width'
        }, 
        notesIconSize: {
            type: Number,
            kComposite: 'notes.icon.size'
        }, 
        notesIconType: {
            type: String,
            kComposite: 'notes.icon.type'
        }, 
        notesIconVisible: {
            type: Boolean,
            kComposite: 'notes.icon.visible'
        }, 
        notesLabelBackground: {
            type: String,
            kComposite: 'notes.label.background'
        }, 
        notesLabelBorderColor: {
            type: String,
            kComposite: 'notes.label.border.color'
        }, 
        notesLabelBorderDashType: {
            type: String,
            kComposite: 'notes.label.border.dashType'
        }, 
        notesLabelBorderWidth: {
            type: Number,
            kComposite: 'notes.label.border.width'
        }, 
        notesLabelColor: {
            type: String,
            kComposite: 'notes.label.color'
        }, 
        notesLabelFont: {
            type: String,
            kComposite: 'notes.label.font'
        }, 
        notesLabelTemplate: {
            type: String | Function,
            kComposite: 'notes.label.template'
        }, 
        notesLabelVisible: {
            type: Boolean,
            kComposite: 'notes.label.visible'
        }, 
        notesLabelRotation: {
            type: Number,
            kComposite: 'notes.label.rotation'
        }, 
        notesLabelFormat: {
            type: String,
            kComposite: 'notes.label.format'
        }, 
        notesLabelPosition: {
            type: String,
            kComposite: 'notes.label.position'
        }, 
        noteslineDashType: {
            type: String,
            kComposite: 'notes.line.dashType'
        }, 
        noteslineWidth: {
            type: Number,
            kComposite: 'notes.line.width'
        }, 
        noteslineColor: {
            type: String,
            kComposite: 'notes.line.color'
        }, 
        noteslineLength: {
            type: Number,
            kComposite: 'notes.line.length'
        }, 
        notesVisual: {
            type: Function,
            kComposite: 'notes.visual'
        }, 
        zIndex: {
            type: Number,
            kComposite: 'zIndex'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartSeriesItem/Series.js